import type { ComparisonObservation } from "../../../domain/insights/comparison-types.js";
import { displaySides } from "./comparison-presentation.js";
import type { AnalysisProps } from "./comparison-observation.js";
import { ComparisonPoints } from "./comparison-points.js";

export function ComparisonMetricTable({
  detail,
  rows,
}: AnalysisProps & {
  rows: Array<{ label: string; observation: ComparisonObservation }>;
}): React.JSX.Element {
  const sides = displaySides(detail.relation);
  return (
    <div>
      {rows.map(({ label, observation: item }) => {
        const percentage = item.metric === "gir" || item.metric === "fairways";
        return (
          <ComparisonPoints
            key={label}
            label={label}
            names={[
              detail.relation[sides[0]].name,
              detail.relation[sides[1]].name,
            ]}
            values={[item[`${sides[0]}Mean`], item[`${sides[1]}Mean`]]}
            description={
              percentage
                ? "Share of recorded holes · Higher is better"
                : item.metric === "putts"
                  ? "Average putts per hole · Lower is better"
                  : `Average ${detail.filters.basis} strokes · Lower is better`
            }
            percentage={percentage}
            higherWins={percentage}
            sample={`${item.n} ${item.unit === "paired-hole" ? "holes" : "rounds"}`}
          />
        );
      })}
    </div>
  );
}
